import { SUPPORT_EMAIL_ADDRESS } from './email';

export const appleAppStoreUrl = 'https://apps.apple.com/us/app/duckbill/id6455085338';
export const googlePlayStoreUrl = 'https://play.google.com/store/apps/details?id=com.getduckbill.duckbill&hl=en&gl=US';

export const termsUrl = 'https://www.getduckbill.com/terms-of-use';
export const privacyUrl = 'https://www.getduckbill.com/duckbill-privacy-statement';
export const smsTermsUrl = 'https://getduckbill.com/sms-terms';
export const contactUrl = `mailto:${SUPPORT_EMAIL_ADDRESS}`;
// Auto-scroll to faq isn't working, so copying a url with the highlighted text to force auto-scroll
export const faqUrl = 'https://www.getduckbill.com/faq';
export const referralsUrl = 'https://referral.duckbill.ai/rnkEym/join';

export const RESUBSCRIBE_EMAIL_URL = `mailto:${SUPPORT_EMAIL_ADDRESS}?subject=Resume Duckbill Subscription`;
